'use strict';

import 'ol/ol.css';

import jQuery from 'jquery';

import Map from 'ol/map';
import View from 'ol/view';
import Overlay from 'ol/overlay';

import Group from 'ol/layer/group';
import Tile from 'ol/layer/tile';
import VectoryLayer from 'ol/layer/vector';

import Style from 'ol/style/style';
import Text from 'ol/style/text';
import Fill from 'ol/style/fill';
import Stroke from 'ol/style/stroke';
import Circle from 'ol/style/circle';

import VectorSource from 'ol/source/vector';
import WMTS from 'ol/source/wmts';
import tilegridWMT from 'ol/tilegrid/wmts';
import GeoJSON from 'ol/format/geojson';

import extent from 'ol/extent';
import interaction from 'ol/interaction';
import Attribution from 'ol/attribution';
import Projection from 'ol/proj/projection';

const SEARCH_MAP_COMPONENT_ATTR = 'data-search-map';
const SEARCH_MAP_COMPONENT_SELECTOR = '[' + SEARCH_MAP_COMPONENT_ATTR + ']';
const SEARCH_MAP_COMPONENT_MAP_PLACEHOLDER = '[data-search-map-placeholder]';
const SEARCH_MAP_COMPONENT_POPUP = '[data-seach-map-popup]';
const SEARCH_MAP_BUTTON_ZOOM_IN = '[data-search-map-zoom-in]';
const SEARCH_MAP_BUTTON_ZOOM_OUT = '[data-search-map-zoom-out]';

const EVENT_MAP_LAYERS_CHANGED = 'event-layer-group-changed';
const EVENT_SEARCH_FORM_DATA_LOADED = 'event-search-panel-form-data-loaded';
const EVENT_SEARCH_MAP_NOTIFICATION = 'event-search-map-notification';
const EVENT_SEARCH_PANEL_CLOSE = 'events-search-panel-close';

const $window = jQuery(window);

export default class SearchMap {

    constructor(element) {
        const component = this;

        component.$element = jQuery(element);
        component.$buttonZoomIn = component.$element.find(SEARCH_MAP_BUTTON_ZOOM_IN);
        component.$buttonZoomOut = component.$element.find(SEARCH_MAP_BUTTON_ZOOM_OUT);

        component.popupElement = document.getElementById('search-map__popup');

        component.popup = new Overlay({
            element: component.popupElement
        });

        component.layerGroup = new Group({
            title: 'Lagen',
            layers: []
        });

        component.setOpenLayersOptions();
        component.setOpenLayersStyles();
        component.createMap();
        // component.bindLayerSwitcher();
        component.bindMapEventListners();

        $window.on(EVENT_SEARCH_FORM_DATA_LOADED, (event, response) => {
            component.loadSearchGeoJSONSources(response);
        });

        component.$buttonZoomIn.on('click', () => {
            let currentZoomLevel = component.map.getView().getZoom();

            component.map.getView().setZoom(currentZoomLevel + 1);
        });

        component.$buttonZoomOut.on('click', () => {
            let currentZoomLevel = component.map.getView().getZoom();

            component.map.getView().setZoom(currentZoomLevel - 1);
        });
    }

    setOpenLayersOptions() {
        const component = this;

        component.extent = [-285401.92, 22598.08, 595401.9199999999, 903401.9199999999];
        component.resolutions = [3440.640, 1720.320, 860.160, 430.080, 215.040, 107.520, 53.760, 26.880, 13.440, 6.720, 3.360, 1.680, 0.840, 0.420];
        component.projection = new Projection({
            code: 'EPSG:28992',
            units: 'm',
            extent: component.extent
        });
    }

    setOpenLayersStyles() {
        const component = this;

        component.styleFunction = (feature) => {
            let style;

            let name = feature.get('name');
            let color = feature.get('layerColor');
            let opacity = feature.get('opacity');
            let strokeWidth = feature.get('strokeWidth');
            let identificationnr = feature.get('identificationnr');

            let zoom = component.map.getView().getZoom();

            switch (feature.getGeometry().getType()) {
                case 'Point':
                    if (name == 'search_area') {
                        style = new Style({
                            image: new Circle({
                                radius: 10,
                                fill: new Fill({
                                    color: 'rgba(0, 0, 0, 1.0)'
                                })
                            })
                        })
                    } else {
                        style = new Style({
                            image: new Circle({
                                radius: 5,
                                stroke: new Stroke({
                                    color: 'rgba(0, 0, 0, 1.0)',
                                    width: 1
                                }),
                                fill: new Fill({
                                    color: (color) ? color : 'rgba(234, 51, 20, 1.0)',
                                })
                            }),

                            text: new Text({
                                offsetY: -20,
                                font: (zoom >= 12) ? '16px Arial' : '0px Arial',
                                text: (identificationnr) ? identificationnr.toString() : '',
                                fill: new Fill({
                                    color: 'rgba(0, 0, 0, 1)'
                                })
                            })
                        })
                    }

                    return style;

                case 'LineString':
                case 'MultiLineString':
                    style = new Style({
                        stroke: new Stroke({
                            color: (color) ? color : 'rgba(115, 184, 65, 1.0)',
                            width: (strokeWidth) ? strokeWidth : 5
                        })
                    })

                    return style;

                case 'Polygon':
                case 'MultiPolygon':
                    if (name == 'search_area') {
                        style = new Style({
                            stroke: new Stroke({
                                color: 'rgba(0, 0, 0, 1)',
                                width: 2
                            })
                        })
                    } else {
                        style = new Style({
                            fill: new Fill({
                                color: (color) ? color : 'rgba(99, 221, 105, 0.45)',
                            })
                        })
                    }

                    return style;

            }
        };
    }

    createMap() {
        const component = this;

        let matrixIds = new Array(14);

        for (let z = 0; z < 15; ++z) {
            matrixIds[z] = 'EPSG:28992:' + z;
        }

        component.map = new Map({
            target: 'search-map__placeholder',
            interactions: interaction.defaults({
                mouseWheelZoom: true
            }),
            controls: [],
            layers: [
                new Group({
                    title: 'Achtergrond',
                    layers: [
                        new Tile({
                            title: 'Luchtfoto',
                            extent: component.extent,
                            visible: false,
                            type: 'base',
                            image: 'images/layer-background-photo.png',
                            source: new WMTS({
                                url: 'https://service.pdok.nl/hwh/luchtfotorgb/wmts/v1_0',
                                layer: 'Actueel_ortho25',
                                matrixSet: 'EPSG:28992',
                                format: 'image/png',
                                projection: component.projection,
                                tileGrid: new tilegridWMT({
                                    origin: extent.getTopLeft(component.extent),
                                    resolutions: component.resolutions,
                                    matrixIds: matrixIds
                                }),
                                attributions: [
                                    new Attribution({
                                        html: '© CC-BY Kadaster',
                                        collapsible: false
                                    }),
                                ],
                            })
                        }),

                        new Tile({
                            title: 'BRT Achtergrondkaart (pastel)',
                            extent: component.extent,
                            visible: true,
                            type: 'base',
                            image: 'images/layer-background-pastel.png',
                            source: new WMTS({
                                url: 'https://service.pdok.nl/brt/achtergrondkaart/wmts/v2_0',
                                layer: 'grijs',
                                matrixSet: 'EPSG:28992',
                                format: 'image/png',
                                projection: component.projection,
                                tileGrid: new tilegridWMT({
                                    origin: extent.getTopLeft(component.extent),
                                    resolutions: component.resolutions,
                                    matrixIds: matrixIds
                                }),
                                attributions: [
                                    new Attribution({
                                        html: '© CC-BY Kadaster',
                                        collapsible: false
                                    }),
                                ],
                            })
                        }),

                        new Tile({
                            title: 'BRT Achtergrondkaart (kleur)',
                            extent: component.extent,
                            visible: false,
                            type: 'base',
                            image: 'images/layer-background-color.png',
                            source: new WMTS({
                                url: 'https://service.pdok.nl/brt/achtergrondkaart/wmts/v2_0',
                                layer: 'standaard',
                                matrixSet: 'EPSG:28992',
                                format: 'image/png',
                                projection: component.projection,
                                tileGrid: new tilegridWMT({
                                    origin: extent.getTopLeft(component.extent),
                                    resolutions: component.resolutions,
                                    matrixIds: matrixIds
                                }),
                                attributions: [
                                    new Attribution({
                                        html: '© CC-BY Kadaster',
                                        collapsible: false
                                    }),
                                ],
                            })
                        }),
                    ]
                }),
            ],
            overlays: [component.popup],
            view: new View({
                minZoom: 4,
                maxZoom: 14,
                projection: component.projection,
                center: [114681.293, 433750.626],
                zoom: 7,
            })
        });
    }

    loadSearchGeoJSONSources(response) {
        const component = this;

        if (component.layerGroup.getLayers()) {
            component.map.removeLayer(component.layerGroup);

            component.layerGroup.getLayers().clear();
        }

        let layers = component.layerGroup.getLayers();

        response.layers.forEach((object, index) => {
            let title = object.properties.name;
            let color = object.properties.color;
            let source = new VectorSource({
                features: (new GeoJSON()).readFeatures(object, {
                    dataProjection: 'EPSG:28992',
                    featureProjection: 'EPSG:3857'
                })
            });
            let zIndex = (object.properties.name == 'Zoekgebied') ? 0 : 1;

            if (source.getFeatures().length > 0) {
                layers.push(
                    new VectoryLayer({
                        title: title,
                        color: color,
                        source: source,
                        style: component.styleFunction,
                        zIndex: zIndex
                    }),
                );
            }
        });

        if (layers.getArray().length > 0) {
            component.map.addLayer(component.layerGroup);
        } else {
            $window.trigger(EVENT_SEARCH_MAP_NOTIFICATION, {
                type: 'search-map__notification--info',
                message: '<strong>Opmerking</strong> Er zijn geen resultaten gevonden. Probeer opnieuw te zoeken.'
            });
        }
    }

    bindMapEventListners() {
        const component = this;

        component.map.getLayerGroup().on('change', () => {
            if (component.layerGroup.getLayers().getArray().length > 0) {
                let layerGroupExtent = extent.createEmpty();

                component.layerGroup.getLayers().getArray().forEach(function (layer) {
                    extent.extend(layerGroupExtent, layer.getSource().getExtent());
                });

                component.map.getView().fit(layerGroupExtent, component.map.getSize());

                $window.trigger(EVENT_MAP_LAYERS_CHANGED, {
                    layers: component.map.getLayerGroup()
                });
            }
        });

        component.map.on('postrender', (event) => {
            $window.trigger(EVENT_MAP_LAYERS_CHANGED, {
                layers: component.map.getLayerGroup()
            });
        });

        component.map.on('click', (event) => {
            $window.trigger(EVENT_SEARCH_PANEL_CLOSE);
        });

        component.map.on('movestart', (event) => {
            $window.trigger(EVENT_SEARCH_PANEL_CLOSE);
        });

        component.map.on('moveend', () => {
            let maxZoomLevel = component.map.getView().getMaxZoom()
            let minZoomLevel = component.map.getView().getMinZoom()
            let currentZoomLevel = component.map.getView().getZoom();

            component.$buttonZoomIn.prop('disabled', false);
            component.$buttonZoomOut.prop('disabled', false);

            if (maxZoomLevel == currentZoomLevel) {
                component.$buttonZoomIn.prop('disabled', true);
            }

            if (minZoomLevel == currentZoomLevel) {
                component.$buttonZoomOut.prop('disabled', true);
            }
        });

        component.map.on('click', (event) => {
            let popupContainer = jQuery(component.popup.getElement());

            let feature = component.map.forEachFeatureAtPixel(event.pixel, (feature, layer) => { return feature; });
            let coordinate = event.coordinate;

            if (feature && feature.get('name') != 'search_area') {
                popupContainer.popover('destroy');

                component.popup.setPosition(coordinate);

                let typesList = {
                    'history': 'historie',
                    'nature': 'natuur',
                    'archeology': 'archeologie',
                    'expectation': 'verwachting',
                };

                let content = '<div>';

                if (feature.get('image') != null) {
                    content += `
                        <img src="${feature.get('image')}">
                    `;
                }

                if (feature.get('layer') != null) {
                    content += `
                        <div class="popover-row">
                            <strong>Laagnummer</strong><br />
                            ${feature.get('layer')}
                        </div>
                    `;
                }

                if (feature.get('element') != null) {
                    content += `
                        <div class="popover-row">
                            <strong>Element</strong><br />
                            ${feature.get('element')}
                        </div>
                    `;
                }

                if (feature.get('name') != null) {
                    content += `
                        <div class="popover-row">
                            <strong>Benaming</strong><br />
                            ${feature.get('name')}
                        </div>
                    `;
                }

                if (feature.get('description') != null) {
                    content += `
                        <div class="popover-row">
                            <strong>Omschrijving</strong><br />
                            ${feature.get('description')}
                        </div>
                    `;
                }

                content += `</ul>`;

                content += `<a href="/rapporten/${typesList[feature.get('type')]}/pdf/${feature.get('id')}" target="_blank">Download PDF</a>`;

                content += '</div>';

                console.log(content)

                popupContainer.popover({
                    placement: 'top',
                    animation: false,
                    html: true,
                    content: content
                });

                popupContainer.popover('show');
            } else {
                popupContainer.popover('destroy');

                component.popup.setPosition(undefined);
            }
        });
    }

}

jQuery(SEARCH_MAP_COMPONENT_SELECTOR).each((index, element) => new SearchMap(element));
